import React from 'react'
import Helmet from 'react-helmet'

import { SEO } from '@talentinc/gatsby-theme-ecom/types/page'

type Props =
  | {
      slug: string
      seo: SEO | null
    }
  | { enabled: boolean }

export const shouldNoIndex = (slug: string, seo: SEO | null): boolean =>
  !seo || seo.noIndex || seo.doNotDeployToProduction || slug.startsWith('new/')

const NoIndex: React.FC<Props> = (props) => {
  if ('enabled' in props && !props.enabled) {
    return null
  } else if ('seo' in props && !shouldNoIndex(props.slug, props.seo)) {
    return null
  }

  return (
    <Helmet>
      <meta name="robots" content="noindex" />
    </Helmet>
  )
}

export default NoIndex
